module.exports = __webpack_public_path__ + "static/media/view medical history.8a2a15aa.svg";